var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{staticClass:"wrapper",attrs:{"id":"app"}},[(!_vm.show)?_c('div',[_c('NavBar'),_c('AsideBar')],1):(_vm.show)?_c('Navigation'):_vm._e(),_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }